export function eurosToCents(price: number | undefined): number | undefined {
  return price !== undefined && price !== null ? Math.round(price * 100) : undefined;
}

export function centsToEuros(price: number | undefined): number | undefined {
  return price !== undefined && price !== null ? Number((price / 100).toFixed(2)) : undefined;
}

export function applyMultiplier(price: number, multiplier: number): number {
  return Math.round(price * multiplier);
}
